import { render, staticRenderFns } from "./system_notice.vue?vue&type=template&id=54d7721f"
import script from "./system_notice.vue?vue&type=script&lang=ts"
export * from "./system_notice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports